module.exports = __webpack_public_path__ + "static/media/_orkney-islands.1fe7288b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_orkney-islands.svg
// module id = 2342
// module chunks = 7